    (function() {
      var root = document.getElementById('vmsw-swp-slider');
      if (!root) return;

      var swiper = new Swiper(root.querySelector('.vmsw__swiper'), {
        direction: 'vertical',
        slidesPerView: 1,
        speed: 450,
        grabCursor: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1
        },
        keyboard: { enabled: true },
        pagination: {
          el: root.querySelector('.vmsw__pagination'),
          clickable: true
        },
        on: {
          slideChange: function() {
            // pause videos on non-active slides
            root.querySelectorAll('.vmsw-video video').forEach(function(v, i) {
              if (i !== swiper.activeIndex && !v.paused) v.pause();
            });
          }
        }
      });

      // Recalculate on resize so slide heights stay correct
      window.addEventListener('resize', function(){ swiper.updateAutoHeight(300); swiper.update(); });
    })();

    (function(){
      
      var root = document.getElementById('tct__inner');
      if (!root || typeof Swiper === 'undefined') return;

      // Thumbs first
      var thumbs = new Swiper(root.querySelector('.tct-thumb-swiper'), {
        slidesPerView: 3,
        spaceBetween: 16,
        watchSlidesProgress: true,
        breakpoints: {
          640: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
          1200:{ slidesPerView: 3 }
        }
      });

      // Main
      var main = new Swiper(root.querySelector('.tct-main-swiper'), {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 450,
        autoHeight: true,
        navigation: {
          prevEl: root.querySelector('.tct-prev'),
          nextEl: root.querySelector('.tct-next')
        },
        thumbs: { swiper: thumbs },
        keyboard: { enabled: true }
      });

      // Keep sizes fresh on resize
      window.addEventListener('resize', function(){ main.updateAutoHeight(300); main.update(); thumbs.update(); });
    })();